class ProductTabs extends HTMLElement {
	constructor() {
		super();

        this.tab = this.querySelectorAll('.tab-title');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');

        if (this.querySelector('.tabs-horizontal')) {
            this.tab[0].classList.add('is-open');
            this.tabContent[0].classList.add('is-active');
        }

        if(this.tab.length > 0) {
            this.tab.forEach((tab) => {
                tab.addEventListener('click', this.tabActive.bind(this));
            });
        }

        if(this.link.length > 0) {
            this.link.forEach((link) => {
                link.addEventListener('click', this.tabToggle.bind(this));
            });
        }
	}

    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.currentTarget,
            id = $this.getAttribute('href').replace('#', '');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }
    }

    // tabToggle(event){
    //     event.preventDefault();
    //     event.stopPropagation();

    //     // var $this = event.target
    //     var $this = event.currentTarget,
    //         // $content = $this.parentNode.nextElementSibling;
    //     var $content = $this.closest('.toggle-title').nextElementSibling;

    //     if($this.classList.contains('is-open')){
    //         $this.classList.remove('is-open');
    //         // $($content).slideUp('slow');
    //                     $content.classList.remove('is-active');

    //     } else {
    //         $this.classList.add('is-open');
    //         // $($content).slideDown('slow');
    //                     $content.classList.add('is-active');

    //     }
    // }

    tabToggle(event){
    event.preventDefault();
    event.stopPropagation();

    var $this = event.currentTarget; // safer than event.target
    var $content = $this.closest('.toggle-title').nextElementSibling;

    if($this.classList.contains('is-open')){
        $this.classList.remove('is-open');
        $content.style.maxHeight = null;
                // $content.style.padding = '0';
        $content.style.transition = 'max-height 0.3s ease';
    } else {
        $this.classList.add('is-open');
        $content.style.maxHeight = $content.scrollHeight + 'px';
        $content.style.transition = 'max-height 0.3s ease';
    }
}
}

customElements.define('product-tab', ProductTabs);